export const MAX_COOKIE_SIZE = 4000;

export const REDIRECT_MAP = {
    basket: '/basket',
    home: '/',
    checkout: '/checkout',
    loves: '/lovelist',
    account: '/profile/MyAccount',
    rewards: '/rewards',
    offers: '/beauty/beauty-offers',
    purchases: '/profile/MyAccount/OrderHistory'
};

export const DEFAULT_REDIRECT = '/';

export const AGENT_HANDOFF_REFERRAL_KEY = 'agentHandoffReferral';

// Query param used by agent partners to identify the referring agent on handoff.
export const AGENT_SOURCE_PARAM = 'agent_source';

// Named accessors for the recognized agent_source values, for use in code that
// references a specific partner (tests, route logic). AGENT_SOURCE_EVENT_MAP
// below is the single source of truth for which sources are recognized.
export const AGENT_SOURCE = {
    CHATGPT: 'chatgpt',
    GOOGLE: 'google'
};

// Single source of truth for recognized agent_source values: maps each to the
// global session event appended to every tracking call for the session.
// Onboarding a new partner = add one entry here.
//
// Created with a null prototype so URL-controlled lookups cannot match inherited
// Object.prototype keys (e.g. 'constructor', 'toString'); unrecognized sources
// reliably resolve to undefined.
//
// Event string values mirror analytics/constants.js (EVENT_313 / EVENT_321),
// which remains canonical. They are duplicated as literals here intentionally:
// importing the analytics constants would create a constants -> analytics ->
// constants circular dependency (analytics/constants.js imports from constants/).
export const AGENT_SOURCE_EVENT_MAP = Object.assign(Object.create(null), {
    [AGENT_SOURCE.CHATGPT]: 'event313',
    [AGENT_SOURCE.GOOGLE]: 'event321'
});

/**
 * Resolves the persisted agent handoff referral value into the global session
 * event that should fire on all tracking calls.
 *
 * @param {string|boolean} referral - Value stored under AGENT_HANDOFF_REFERRAL_KEY.
 *        A recognized source string (e.g. 'google') maps to its event; a legacy
 *        truthy value (true / 'true') falls back to the ChatGPT event for
 *        backward compatibility.
 * @returns {string|undefined} The event string, or undefined when no agentic
 *        session event should fire.
 */
export const getAgentHandoffEvent = referral => {
    if (!referral) {
        return undefined;
    }

    // Safe against inherited keys: AGENT_SOURCE_EVENT_MAP has a null prototype.
    if (AGENT_SOURCE_EVENT_MAP[referral]) {
        return AGENT_SOURCE_EVENT_MAP[referral];
    }

    // Legacy sessions stored the boolean flag `true` (or string 'true') before
    // multi-agent routing existed; treat those as ChatGPT.
    if (referral === true || referral === 'true') {
        return AGENT_SOURCE_EVENT_MAP[AGENT_SOURCE.CHATGPT];
    }

    return undefined;
};
